import React, { useRef, useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  List,
  IconButton,
  ListItemAvatar,
  Avatar,
  ListItem,
  ListItemText,
} from '@mui/material';
import {
  UploadFile as UploadFileIcon,
  Delete as DeleteIcon,
  AttachFile as AttachFileIcon,
} from '@mui/icons-material';
import { Box } from '@mui/system';
export const FileUpload = ({
  label = '',
  onChange,
  value = '',
  name = '',
  size = 'small',
  margin = 'dense',
  fullWidth = true,
  error = false,
  helperText = '',
  multiple = false,
  ...props
}) => {
  const ref = useRef(null);
  const [fileList, setFileList] = useState([]);
  useEffect(() => {
    if (!multiple && value?.isAvailable) {
      setFileList([[value]]);
      return;
    }
  }, [value]);
  const submitOnchange = (newValue) => {
    const submit = (value) =>
      onChange &&
      onChange({
        persist: () => {},
        target: {
          type: 'change',
          name,
          value,
        },
      });
    if (!multiple) {
      if (!newValue?.length) {
        return submit(null);
      }
      return submit(newValue[0]);
    }

    submit(newValue);
  };
  const onAddFile = (e) => {
    const file = e?.target?.files;
    if (!file?.length) {
      return;
    }
    if (!multiple) {
      setFileList([file]);
      submitOnchange(file);
    } else {
      const tmp = fileList.map((item) => item);
      const convertDataFile = Array.from(file).map((item) => tmp.push([item]));
      setFileList(tmp);
      submitOnchange(tmp);
    }
  };
  const onDeleteFile = (index) => {
    const tmpFiles = fileList.filter((fItem, fIndex) => fIndex != index);
    setFileList(tmpFiles);
  };
  const showListFile = () => (
    <List dense={true}>
      {fileList?.map(([item], index) => (
        <ListItem
          key={`file-item-${index}`}
          secondaryAction={
            <IconButton edge="end" aria-label="delete" onClick={() => onDeleteFile(index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          }
        >
          <ListItemAvatar>
            <AttachFileIcon fontSize="small" />
          </ListItemAvatar>
          <ListItemText
            sx={item?.isAvailable && { cursor: 'pointer' }}
            onClick={() => {
              if (item?.isAvailable) {
                window.open(`${process.env.REACT_APP_API_URL}/${item?.filePath}`, '_blank');
              }
            }}
            primary={item?.name}
          />
        </ListItem>
      ))}
    </List>
  );

  return (
    <>
      <FormControl
        {...{
          size,
          fullWidth,
          margin,
        }}
        sx={{ mt: 3 }}
      >
        {/* <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel> */}
        <Button variant="outlined" component="label" sx={{ width: 'fit-content' }}>
          <UploadFileIcon />
          {label || 'Tải lên tệp'}
          <input type="file" hidden ref={ref} onChange={(e) => onAddFile(e)} multiple={multiple} />
        </Button>
        {fileList?.length ? <Box>{showListFile()}</Box> : null}
      </FormControl>
      {error && (
        <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px' }}>{helperText}</div>
      )}
    </>
  );
};
